import { BannerCard } from '@components/molecules'
import { MenuItemType } from '@utils/types'
import { WContainer } from '../../atoms'
import styles from './BannerDouble.module.sass'

interface Props {
  className?: string
  theme?: 'white' | 'neutral20'
  items: MenuItemType[]
}

const BannerDouble = (props: Props) => {
  const { className = '', theme = 'neutral20', items = [] } = props

  const classeNames = `
  ${styles.root} 
  ${styles[`root--${theme}`]}
  ${className ? className : ''}`

  return (
    <div className={classeNames}>
      <WContainer className={styles.container}>
        {items?.[0] && <BannerCard item={items[0]} />}
        {items?.[1] && <BannerCard item={items[1]} />}
      </WContainer>
    </div>
  )
}

export default BannerDouble
